export default "__VITE_ASSET__0qUjM5TT__"